export encode_html = (string) ->
  string.replace(/[\u00A0-\u9999<>\&]/g, (i) -> '&#'+i.charCodeAt(0)+';')